import { ModalBackdropStyled, SideSheetBody } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: absolute;
  right: 0;
  top: 40px;
  height: calc(100vh- 40px);
  background: rgba(255, 255, 255, 0.65);
  z-index: 2;
`;

export const DrawerOuterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 25%;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  box-shadow: ${({ theme }) => theme.componentStyles.boxShadow};
`;

export const SideSheetCloseContainer = styled.div`
  position: absolute;

  ${({ theme }) => css`
    right: ${theme.spacings[400]};
    top: ${theme.spacings[200]};
  `}
`;

export const SideSheetBodyStyled = styled(SideSheetBody)`
  flex-direction: column;
`;
